
// almost ready to delete this, will need to rebuild the food preferences page where these can be modified, almost everything that was here was transitioned to store/data.js

export default {
    namespaced: true,

    state: {
        weeklyBudget: 150,
    },

    actions: {
        weeklyBudget({commit}, value) {
            commit('weeklyBudget',value)
        },
    },

    mutations: {
        weeklyBudget(state,value) {
            state.weeklyBudget = value;
            state.savedFoodPreferences = false
        },
    },

    getters: {
        weeklyBudget(state) {
            return state.weeklyBudget
        },
    }

}
